import { HostBinding, Directive, Component } from '@angular/core';
import { PageComponent, PageService } from './page-component';
import { Shell } from './shell';
import { FieldError } from './field-error';

@Component({
    template: ''
})
export class DialogComponent extends PageComponent {
    constructor(
        pageService : PageService = null
    ) {
        super(pageService);
    }

    @HostBinding('class.dialog-content')
    isDialogContent : boolean = true;

    public init(...args) {

    }

    public showError(message : string, fieldErrors : FieldError[] = []) {
        super.showError(message, fieldErrors);
        this.shell.shakeDialog();
    }

    public showDialog(name : string | any, ...args : any[]) {
        this.shell.showDialog(name, ...args);
    }

    public close() {
        this.shell.hideDialog();
    }
}